import { gql } from "@apollo/client";
import { System } from "../../..";

export const WIDGET_CALLS = gql`
  query Widget($domain: String!, $input: BasicQueryInfoInput!) {
    widget {
      info(domain: $domain, input: $input) {
        widget_id
        name
        placement
        display_order
        type
        page
        data
        auto_reports
      }
    }
  }
`

export const UPDATE_WIDGET = gql`
  mutation Update($domain: String!, $input: [WidgetInput!]!) {
    widget {
      update(domain: $domain, input: $input) {
        code
        success
        message
        updatedValues {
          widget_id
          name
          placement
          display_order
          type
          page
          data
          auto_reports
        }
      }
    }
  }
` // TODO make fragment

export const DELETE_WIDGET = gql`
  mutation Delete($domain: String!, $widgetIds: [Int!]!) {
    widget {
      delete(domain: $domain, widget_ids: $widgetIds) {
        code
        success
        message
        updatedValues {
          widget_id
          name
          placement
          display_order
          type
          page
          data
          auto_reports
        }
      }
    }
  }
` // TODO make fragment

export const CREATE_WIDGET = gql`
  mutation Create($domain: String!, $input: [WidgetInput!]!) {
    widget {
      create(domain: $domain, input: $input) {
        updatedValues {
          widget_id
          name
          placement
          display_order
          type
          page
          data
          auto_reports
        }
      }
    }
  }
` // TODO make fragment

export interface Widget {
  widget_id: number;
  name: string;
  placement: number;
  display_order: number;
  type: number;
  page: number;
  data: number[];
  auto_reports: number[];
}

export interface WidgetResponse {
  widget: {
    info: Widget;
  }
}

export interface UpdateWidgetResponse {
  widget: {
    update: {
      code: number;
      success: boolean;
      message: string;
      updatedValues: Widget;
    }
  }
}

export interface CreateWidgetResponse {
  widget: {
    create: {
      code: number;
      success: boolean;
      message: string;
      updatedValues: Widget;
    }
  }
}

export interface DeleteWidgetResponse {
  widget: {
    delete: {
      code: number;
      success: boolean;
      message: string;
      updatedValues: Widget;
    }
  }
}

